import React from 'react';
import propTypes from 'prop-types';
import BrandLogo from 'tailwind-components/BrandLogo/BrandLogo';

/**
 * branding above the sunshine login form. with a remembered agency it shows that
 * agency's logo; with no agency known yet it stays neutral and only greets the user
 * @param hasKnownBrand - whether an agency has ever been seen on this browser
 */
export default function SunshineLoginBranding({ hasKnownBrand = false }) {
  // nobody has signed in on this browser yet, so there is no brand to be sure of
  if (!hasKnownBrand) {
    return (
      <div className='w-4/5 flex flex-col items-center'>
        <span className='text-[35px] text-center text-primary'>Welcome</span>
      </div>
    );
  }

  return (
    <div className='w-4/5 flex flex-col items-center'>
      <BrandLogo
        variant='fullLogo'
        alt='Portal logo'
        // the bundled lockup is wide, so it is sized by width and left to find its
        // own height. an agency logo can be any shape, hence the height cap there
        className='h-auto max-w-[280px]'
        agencyClassName='h-auto max-h-[200px] max-w-[320px]'
      />
    </div>
  );
}

SunshineLoginBranding.propTypes = {
  hasKnownBrand: propTypes.bool
};
